export default {
  SET_ZONES: (state, data) => {
    state.zones = data;
  },
  SET_ZONE: (state, data) => {
    state.zone = data;
  },
};
